import _ from "lodash";
import {
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  TIKTOK,
  META,
  LINKEDIN,
  VIDEO_FORMATS,
  IMAGE_FORMATS,
  ADS_TIKTOK_CAMPAIGN_OBJECTIVES_VALID_WITH_IMAGES,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_MEDIA_FROM_UPLOAD,
  ADS_CAMPAIGN_MEDIA_FROM_CREATIFY,
  VIDEO_PENDING_STATUS_CREATIFY,
  ALL_VIDEO_FAILED_STATUS_CREATIFY,
  VIDEO_RUNNING_STATUS_CREATIFY,
  VIDEO_IN_QUEUE_STATUS_CREATIFY,
  ADS_CAMPAIGN_MEDIA_FROM_FACEBOOK_POST,
  ADS_CAMPAIGN_MEDIA_FROM_INSTAGRAM_POST,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY,
  GOOGLE,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_OBJECTIVES_WITH_DESTINATION_TYPE_META,
  ADS_CAMPAIGN_AD_FORMAT_DESKTOP_FEED_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_INSTREAM_VIDEO_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_MARKETPLACE_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_PROFILE_FEED_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_WATCH_FEED_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_EXPLORE_IMMERSIVE,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_EXPLORE_GRID_HOME,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_PROFILE_FEED,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_SEARCH_GRID,
  ADS_CAMPAIGN_AD_FORMAT_MESSENGER_MOBILE_INBOX_MEDIA,
  ADS_CAMPAIGN_AD_FORMAT_MESSENGER_MOBILE_STORY_MEDIA,
  ADS_CAMPAIGN_AD_FORMAT_RIGHT_COLUMN_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_SUGGESTED_VIDEO_DESKTOP,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
  tiktokCurrenciesData,
  ADS_CAMPAIGN_PLATFORM_MIN_BUDGET_IN_USD,
  ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD,
  ADS_CAMPAIGN_TYPE_SEARCH_OPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
  ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD_OPTION,
  PLATFORMS_WITH_USE_CAMPAIGN_BUDGET_OPTIONAL,
  ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
  ADS_CAMPAIGN_MEDIA_FROM_PARTNERSHIP_POST,
  ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST,
  BUDGETS_WITH_ONLY_CAMPAIGN_LEVEL,
  ADS_CAMPAIGN_OBJECTIVES_WITH_IS_POST_AD,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_IS_POST_AD_EXCLUDED,
  ADS_TIKTOK_PLACEMENT_TIKTOK,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_ORDER_SELF_FIRST,
} from "../utils/constants";
import {
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  CLICKS_BY_PLATFORM,
  CPA,
  DAY_COUNT,
  DATE_DAY_AND_MONTH_SHORT,
  IMPRESSIONS_BY_PLATFORM,
  MAIN_ACTIONS_BY_PLATFORM,
  MONTH_COUNT,
  RESULTS,
  SPEND,
  WEEK_COUNT,
  MONTH_SHORT,
} from "../i18n/keysTranslations";
import i18next from "i18next";
import { getUniqueID, numberDecimal } from "../utils/numbers";
import differenceInDays from "date-fns/differenceInDays";
import { getCurrencyAdAccountPlatform } from "../actions/getters";
import { enrichResultWithGoogleMultipleConversions } from "./google";

import { LaunchError } from "../utils/errors";
import { store } from "../app/store";

export const getStatusAdsCampaign = ({ states, target = "general" }) => {
  const status = states?.[target];
  return status;
};

export const getMetricsValueType = (statistic) => {
  switch (statistic) {
    case "impressions":
    case "clicks":
      return "number";

    case "ctr":
      return "percentage";

    case "mainActionLabel":
    case "currency":
      return "string";

    default:
      return "number";
  }
};

export const getGeneralStatistics = (statistics) => {
  const platforms = Object.keys(statistics).filter(
    (platform) => platform !== "total"
  );
  let generalStatistics = {};
  let lastUpdatedTime;

  const platformsWithValue = {};
  let platformsWithFrequency = 0;
  let platformsWithRoas = 0;

  platforms.forEach((platform) => {
    const platformStatistics = statistics[platform];
    if (!lastUpdatedTime) {
      lastUpdatedTime = platformStatistics.lastUpdatedTime;
    }

    if (lastUpdatedTime < platformStatistics.lastUpdatedTime) {
      lastUpdatedTime = platformStatistics.lastUpdatedTime;
    }

    Object.keys(platformStatistics).forEach((statistic) => {
      const valueType = getMetricsValueType(statistic);

      if (
        statistic === "frequency" &&
        Number(platformStatistics[statistic]) > 0
      ) {
        platformsWithFrequency++;
      }

      if (statistic === "roas") {
        const roasValue = Number(platformStatistics[statistic]);
        if (!Number.isFinite(roasValue) || Number(roasValue) <= 0) return;
        generalStatistics.roas = (generalStatistics.roas || 0) + roasValue;
        platformsWithRoas += 1;
        return;
      }

      if (valueType === "number" || valueType === "percentage") {
        if (!generalStatistics[statistic]) {
          generalStatistics[statistic] = 0;
        }
        generalStatistics[statistic] += Number(platformStatistics[statistic]);
      }
      if (valueType === "string") {
        generalStatistics[statistic] = platformStatistics[statistic];
      }
    });
  });

  Object.keys(generalStatistics).forEach((statistic) => {
    const valueType = getMetricsValueType(statistic);

    if (statistic === "frequency") {
      generalStatistics[statistic] =
        generalStatistics[statistic] / platformsWithFrequency;
      return;
    }

    if (statistic === "roas") {
      generalStatistics[statistic] = platformsWithRoas
        ? generalStatistics[statistic] / platformsWithRoas
        : 0;
      return;
    }

    if (statistic === "costPerMainAction") {
      const mainAction = generalStatistics["mainAction"] || 0;
      const spend = generalStatistics["spend"] || 0;

      if (!mainAction) {
        generalStatistics[statistic] = 0;
        return;
      }

      generalStatistics[statistic] = spend / mainAction || 0;
      return;
    }
    if (statistic === "ctr") {
      const click = generalStatistics["click"] || 0;
      const impressions = generalStatistics["impressions"] || 0;
      generalStatistics[statistic] = (click / impressions) * 100 || 0;
      return;
    }
    if (statistic === "cpc") {
      const click = generalStatistics["click"] || 0;
      const spend = generalStatistics["spend"] || 0;
      if (!click) {
        generalStatistics[statistic] = 0;
        return;
      }

      generalStatistics[statistic] = spend / click || 0;
      return;
    }
    if (statistic === "cpm") {
      const impressions = generalStatistics["impressions"] || 0;
      const spend = generalStatistics["spend"] || 0;
      generalStatistics[statistic] = impressions
        ? (spend / impressions) * 1000
        : 0;
      return;
    }
    if (valueType === "percentage") {
      const platformsWithStatistic = platformsWithValue[statistic] || platforms;

      generalStatistics[statistic] =
        generalStatistics[statistic] / platformsWithStatistic.length;
    }
  });

  // Compute frequency from impressions/reach (not summed from platforms)
  const impressions = generalStatistics["impressions"] || 0;
  const reach = generalStatistics["reach"] || 0;
  generalStatistics.frequency = reach > 0 ? impressions / reach : 0;

  if (_.isEmpty(generalStatistics)) {
    return {};
  }

  return { ...generalStatistics, lastUpdatedTime };
};

export const getCampaignUpdatedByStatus = ({
  campaign,
  status,
  target = "general",
  platform,
  assetsGroupID,
  adGroupID,
  adID,
}) => {
  let objectUpdate = _.cloneDeep(campaign);
  switch (target) {
    case "campaign":
      return updateCampaignByCampaignStatus({ campaign: objectUpdate, status });
    case "platform":
      return updateCampaignByPlatformStatus({
        campaign: objectUpdate,
        platform,
        status,
      });
    case "assetsGroup":
      return updateCampaignByAssetsGroupStatus({
        campaign: objectUpdate,
        platform,
        assetsGroupID,
        status,
      });
    case "adGroup":
      return updateCampaignByAdGroupStatus({
        campaign: objectUpdate,
        platform,
        adGroupID,
        status,
      });
    case "ad":
      return updateCampaignByAdStatus({
        campaign: objectUpdate,
        platform,
        adGroupID,
        adID,
        status,
      });
    default:
      return objectUpdate;
  }
};

const updateCampaignByCampaignStatus = ({ campaign, status }) => {
  const objectUpdate = _.cloneDeep(campaign);

  objectUpdate.states.general = status;

  objectUpdate.platforms?.forEach((platform) => {
    const currentStatus = objectUpdate.states[platform];
    if (currentStatus === ADS_CAMPAIGN_STATUS_DRAFT) return;
    objectUpdate.states[platform] = status;
  });

  return objectUpdate;
};

const updateCampaignByPlatformStatus = ({ campaign, platform, status }) => {
  let objectUpdate = _.cloneDeep(campaign);
  const { platforms } = objectUpdate;

  // Actualiza el estado de la plataforma
  objectUpdate.states[platform] = status;

  // Verifica si hay alguna plataforma activa
  const hasOnePlatformActive = platforms.some(
    (platformKey) =>
      objectUpdate?.states?.[platformKey] === ADS_CAMPAIGN_STATUS_ACTIVE
  );

  // Si no queda ninguna plataforma activa, desactiva la campaña
  if (!hasOnePlatformActive) {
    return updateCampaignByCampaignStatus({ campaign: objectUpdate, status });
  }

  // Si la campaña está desactivada y se activa una plataforma, activa la campaña
  if (
    status === ADS_CAMPAIGN_STATUS_ACTIVE &&
    objectUpdate.states.general !== ADS_CAMPAIGN_STATUS_ACTIVE
  ) {
    objectUpdate.states.general = ADS_CAMPAIGN_STATUS_ACTIVE;
  }

  return objectUpdate;
};

const updateCampaignByAssetsGroupStatus = ({
  campaign,
  platform,
  assetsGroupID,
  status,
}) => {
  let objectUpdate = _.cloneDeep(campaign);

  // Encuentra el adGroup correspondiente al assetsGroupID y platform
  objectUpdate.assetsGroups?.forEach((assetsGroup, assetsGroupIndex) => {
    if (
      assetsGroup.platform === platform &&
      assetsGroupIndex === assetsGroupID
    ) {
      // Actualiza el estado del assetsGroup
      objectUpdate.assetsGroups[assetsGroupIndex].status = status;
    }
  });

  return objectUpdate;
};

const updateCampaignByAdGroupStatus = ({
  campaign,
  platform,
  adGroupID,
  status,
}) => {
  let objectUpdate = _.cloneDeep(campaign);

  // Encuentra el adGroup correspondiente al adGroupID y platform
  objectUpdate.adsGroups?.forEach((adGroup, adGroupIndex) => {
    if (adGroup.platform === platform && adGroupIndex === adGroupID) {
      // Actualiza el estado del adgroup
      objectUpdate.adsGroups[adGroupIndex].status = status;
    }
  });

  return objectUpdate;
};

const updateCampaignByAdStatus = ({
  campaign,
  platform,
  adGroupID,
  adID,
  status,
}) => {
  let objectUpdate = _.cloneDeep(campaign);

  // Actualiza el estado del ad correspondiente
  objectUpdate.adsGroups.forEach((adGroup, adGroupIndex) => {
    if (adGroup.platform === platform && adGroupIndex === adGroupID) {
      if (adGroup.ads[adID]) {
        objectUpdate.adsGroups[adGroupIndex].ads[adID].status = status;
      }
    }
  });

  return objectUpdate;
};

export const formattedIframeByType = ({ iframe = "", type, isMobile }) => {
  const commonDimensions = { width: 322, height: 570 };
  const dimensions = {
    [ADS_CAMPAIGN_AD_FORMAT_DESKTOP_FEED_STANDARD]: { width: 500, height: 760 },
    [ADS_CAMPAIGN_AD_FORMAT_INSTREAM_VIDEO_MOBILE]: { width: 322, height: 570 },
    [ADS_CAMPAIGN_AD_FORMAT_MARKETPLACE_MOBILE]: { width: 298, height: 444 },
    [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_PROFILE_FEED_MOBILE]: {
      width: 324,
      height: 584,
    },
    [ADS_CAMPAIGN_AD_FORMAT_WATCH_FEED_MOBILE]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD]: { width: 322, height: 650 },
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_EXPLORE_IMMERSIVE]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_EXPLORE_GRID_HOME]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_PROFILE_FEED]: {
      width: 322,
      height: 642,
    },
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_SEARCH_GRID]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_MESSENGER_MOBILE_INBOX_MEDIA]: {
      width: 372,
      height: 778,
    },
    [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL]: { width: 322, height: 625 },
    [ADS_CAMPAIGN_AD_FORMAT_MESSENGER_MOBILE_STORY_MEDIA]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_RIGHT_COLUMN_STANDARD]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_SUGGESTED_VIDEO_DESKTOP]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED]: commonDimensions,
    [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD]: {
      width: 320,
      height: 500,
    },
    [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO]: {
      width: 250,
      height: 556,
    },
    [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS]: {
      width: 254,
      height: 596,
    },
  };

  let newWidth;
  let newHeight;

  if (dimensions[type]) {
    newWidth = dimensions[type].width;
    newHeight = dimensions[type].height;
  } else {
    newWidth = commonDimensions.width;
    newHeight = commonDimensions.height;
  }

  if (!iframe) {
    return {
      iframe: "",
      src: "",
      width: newWidth,
      height: newHeight,
    };
  }

  const src = iframe.match(/src="([^"]*)"/)?.[1]?.replace(/&amp;/g, "&");

  let iframeFormatted = iframe
    .replace(/width="[^"]*"/, `width="${newWidth}"`)
    .replace(/height="[^"]*"/, `height="${newHeight}"`)
    .replace(/scrolling="[^"]*"/, `scrolling="no"`);

  const newStyle = isMobile
    ? "border: none; overflow: hidden;"
    : "border: 1px solid white; overflow: hidden;";
  if (iframeFormatted.includes('style="')) {
    iframeFormatted = iframeFormatted.replace(
      /style="[^"]*"/,
      `style="${newStyle}"`
    );
  } else {
    iframeFormatted = iframeFormatted.replace(
      "<iframe",
      `<iframe style="${newStyle}"`
    );
  }
  return { iframe: iframeFormatted, width: newWidth, height: newHeight, src };
};

export const getDefaultEventTrackingMeta = (objective) => {
  switch (objective) {
    case ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION:
      return "CONTENT_VIEW";
    case ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION:
      return "COMPLETE_REGISTRATION";
    case ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION:
      return "PURCHASE";
    default:
      return "";
  }
};
export const getDefaultEventTrackingTikTok = (objective) => {
  switch (objective) {
    case ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION:
      return "ON_WEB_REGISTER";
    case ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION:
      return "SHOPPING";
    default:
      return "";
  }
};
export const getDefaultPlatformData = (platform) => {
  if (platform === TIKTOK) {
    return {
      integrationID: "",
      adAccountID: "",
      identityTikTokID: "",
      trackingID: "",
      trackingCustomEventID: "",
    };
  }
  if (platform === META) {
    return {
      integrationID: "",
      adAccountID: "",
      pageID: "",
      instagramID: "",
      trackingID: "",
      trackingCustomEventID: "",
    };
  }
  if (platform === GOOGLE) {
    return {
      integrationID: "",
      adAccountID: "",
      trackingID: "",
      trackingCustomEventID: "",
    };
  }
};
export const getFormatsUpload = ({
  platforms,
  objective,
  platform,
  mode = "general",
}) => {
  if (mode === "general") {
    const hasTikTokPlatform = platforms?.includes(TIKTOK);

    if (!hasTikTokPlatform) {
      return VIDEO_FORMATS.concat(IMAGE_FORMATS);
    }

    if (ADS_TIKTOK_CAMPAIGN_OBJECTIVES_VALID_WITH_IMAGES.includes(objective)) {
      return VIDEO_FORMATS.concat(IMAGE_FORMATS);
    }

    return VIDEO_FORMATS;
  }

  if (platform === TIKTOK) {
    return VIDEO_FORMATS;
  }

  return VIDEO_FORMATS.concat(IMAGE_FORMATS);
};

export const formatMediaUrl = (content) => {
  const isCarousel = content?.isCarousel === true;

  if (content?.from === ADS_CAMPAIGN_MEDIA_FROM_FACEBOOK_POST) {
    return {
      url: content.url || "",
      isCarousel: isCarousel,
      carouselImages: isCarousel ? content.carouselImages : null,
      mediaData: {
        from: ADS_CAMPAIGN_MEDIA_FROM_FACEBOOK_POST,
        postID: content.id,
        isCarousel: content.isCarousel,
      },
    };
  }
  if (content.from === ADS_CAMPAIGN_MEDIA_FROM_INSTAGRAM_POST) {
    return {
      url: content.url || "",
      isCarousel: isCarousel,
      carouselImages: isCarousel ? content.carouselImages : null,
      mediaData: {
        from: ADS_CAMPAIGN_MEDIA_FROM_INSTAGRAM_POST,
        postID: content.id,
        isCarousel: content.isCarousel,
      },
    };
  }
  if (content.from === ADS_CAMPAIGN_MEDIA_FROM_PARTNERSHIP_POST) {
    return {
      url: content.url || "",
      isCarousel: isCarousel,
      carouselImages: isCarousel ? content.carouselImages : null,
      mediaData: {
        from: ADS_CAMPAIGN_MEDIA_FROM_PARTNERSHIP_POST,
        platform: content.platform,
        postID: content.id,
        isCarousel: content.isCarousel,
      },
    };
  }
  if (content?.from === ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST) {
    const postID = content.postId || content.postID;
    return {
      url: content.url || "",
      mediaData: {
        from: ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST,
        postID,
        ...(content.mediaType && { mediaType: content.mediaType }),
      },
    };
  }

  if (content?.from === ADS_CAMPAIGN_MEDIA_FROM_UPLOAD) {
    return {
      url: content.url,
      id: content?.id || null,
      isCarousel: isCarousel,
      carouselImages: isCarousel ? content.carouselImages : null,
      mediaData: {
        from: ADS_CAMPAIGN_MEDIA_FROM_UPLOAD,
      },
    };
  }

  return {
    url: content.url,
    id: content?.id || null,
    isCarousel: isCarousel,
    carouselImages: isCarousel ? content.carouselImages : null,
    mediaData: {
      from: ADS_CAMPAIGN_MEDIA_FROM_UPLOAD,
    },
  };
};

/** Build `carouselImages` entries expected by campaign/backend (`{ url, rating, id }`). */
export const buildCarouselImagesForCampaign = (
  urls,
  { ratings = [], parentId = null } = {}
) =>
  urls
    .map((urlOrObject, index) => {
      const url =
        typeof urlOrObject === "string" ? urlOrObject : urlOrObject?.url || "";
      if (!url) return null;

      const ratingFromObject =
        typeof urlOrObject === "object" ? urlOrObject?.rating : undefined;
      const rating = ratingFromObject ?? ratings[index] ?? null;

      const id =
        typeof urlOrObject === "object" && urlOrObject?.id != null
          ? urlOrObject.id
          : parentId != null
            ? `${parentId}-${index}`
            : null;

      return { url, rating, id };
    })
    .filter(Boolean);

/** Map items built in ModalCreateWithIA "save to gallery" into campaign `mediaUrls` entries. */
export const campaignMediaEntriesFromAISaveItems = (itemsToUpload) => {
  if (!Array.isArray(itemsToUpload) || itemsToUpload.length === 0) {
    return [];
  }

  const entries = [];

  itemsToUpload.forEach((item) => {
    if (item?.type === "carousel" && Array.isArray(item.urls)) {
      const urls = item.urls.filter(Boolean);
      if (urls.length === 0) return;

      const carouselImages = buildCarouselImagesForCampaign(urls, {
        ratings: item.ratings,
        parentId: item.id ?? null,
      });
      if (carouselImages.length === 0) return;

      entries.push(
        formatMediaUrl({
          url: carouselImages[0].url,
          id: item.id ?? null,
          isCarousel: true,
          carouselImages,
          from: ADS_CAMPAIGN_MEDIA_FROM_UPLOAD,
        })
      );
      return;
    }

    const url = typeof item?.url === "string" ? item.url : "";
    if (url) {
      entries.push(
        formatMediaUrl({
          url,
          id: item.id ?? null,
          from: ADS_CAMPAIGN_MEDIA_FROM_UPLOAD,
        })
      );
    }
  });

  return entries;
};
export const formatMediaUrlAdFromCreatify = (videoData) => ({
  url: videoData.videoOutput || "",
  mediaData: {
    from: ADS_CAMPAIGN_MEDIA_FROM_CREATIFY,
    videoID: videoData.id,
    status: videoData.status,
    preview: videoData.preview,
  },
});

export const generalFormatMediaUrl = ({ from, content }) => {
  switch (from) {
    case "upload":
      return formatMediaUrl(content);

    case "creatify":
      return formatMediaUrlAdFromCreatify(content);
  }
};

export const getAdsWithUnRenderedAndFailedRenderedMedia = (campaign = {}) => {
  try {
    let adsWithUnRenderedMedia = {};
    let adsWithRenderFailedMedia = {};
    campaign?.adsGroups?.forEach((adsGroup) => {
      const ads = adsGroup?.ads || [];
      ads.forEach((ad) => {
        const mediaData = ad?.mediaData || [];
        const mediaUrls = ad?.mediaUrls || [];

        mediaData.forEach((mediaDataItem, index) => {
          const isUnRenderedMedia =
            mediaDataItem?.from === ADS_CAMPAIGN_MEDIA_FROM_CREATIFY &&
            mediaDataItem?.status === VIDEO_PENDING_STATUS_CREATIFY &&
            !mediaUrls[index];
          const isRenderFailedMedia =
            mediaDataItem?.from === ADS_CAMPAIGN_MEDIA_FROM_CREATIFY &&
            ALL_VIDEO_FAILED_STATUS_CREATIFY.includes(mediaDataItem?.status) &&
            !mediaUrls[index];

          if (isUnRenderedMedia) {
            const videoID = mediaDataItem?.videoID;
            if (!adsWithUnRenderedMedia[videoID]) {
              adsWithUnRenderedMedia[videoID] = {
                adIDs: [],
                videoID,
              };
            }
            adsWithUnRenderedMedia[videoID].adIDs.push(ad.id);
          }

          if (isRenderFailedMedia) {
            const videoID = mediaDataItem?.videoID;
            if (!adsWithRenderFailedMedia[videoID]) {
              adsWithRenderFailedMedia[videoID] = {
                adIDs: [],
                videoID,
              };
            }
            adsWithRenderFailedMedia[videoID].adIDs.push(ad.id);
          }
        });
      });
    });

    adsWithUnRenderedMedia = Object.values(adsWithUnRenderedMedia);
    adsWithRenderFailedMedia = Object.values(adsWithRenderFailedMedia);
    return {
      ok: true,
      adsWithUnRenderedMedia,
      adsWithRenderFailedMedia,
    };
  } catch (error) {
    store.dispatch(
      LaunchError(error, false, [], {
        functionName: "getAdsWithUnRenderedAndFailedRenderedMedia",
        capture: "exception",
      })
    );
    console.error("Error getAdsWithUnRenderedAndFailedRenderedMedia", error);
    return {
      ok: false,
      adsWithUnRenderedMedia: [],
      adsWithRenderFailedMedia: [],
    };
  }
};

export const getAdsWithRenderingMedia = (campaign = {}) => {
  try {
    let adsWithRenderingMedia = {};
    campaign?.adsGroups?.forEach((adsGroup) => {
      const ads = adsGroup?.ads || [];
      ads.forEach((ad) => {
        const statusInRendering = [
          VIDEO_RUNNING_STATUS_CREATIFY,
          VIDEO_IN_QUEUE_STATUS_CREATIFY,
        ];

        const mediaData = ad?.mediaData || [];
        const mediaUrls = ad?.mediaUrls || [];

        mediaData.forEach((mediaDataItem, index) => {
          const isRenderingMedia =
            mediaDataItem?.from === ADS_CAMPAIGN_MEDIA_FROM_CREATIFY &&
            statusInRendering.includes(mediaDataItem?.status) &&
            !mediaUrls[index];

          if (isRenderingMedia) {
            const videoID = mediaDataItem?.videoID;

            if (!adsWithRenderingMedia[videoID]) {
              adsWithRenderingMedia[videoID] = {
                adIDs: [],
                videoID,
              };
            }
            adsWithRenderingMedia[videoID].adIDs.push(ad.id);
          }
        });
      });
    });

    adsWithRenderingMedia = Object.values(adsWithRenderingMedia);
    return {
      ok: true,
      adsWithRenderingMedia,
    };
  } catch (error) {
    store.dispatch(
      LaunchError(error, false, [], {
        functionName: "getAdsWithRenderingMedia",
        capture: "exception",
      })
    );
    console.error("Error getAdsWithRenderingMedia", error);
    return {
      ok: false,
      adsWithRenderingMedia: [],
    };
  }
};

export const mapStatusFromOptimization = (status) => {
  switch (status) {
    case true:
      return ADS_CAMPAIGN_STATUS_ACTIVE;

    case false:
      return ADS_CAMPAIGN_STATUS_DEACTIVATED;

    default:
      return "";
  }
};

export const mapTitleStatisticsByMetric = ({ metric }) => {
  switch (metric) {
    case "spend":
      return `${i18next.t(SPEND)}`;
    case "mainAction":
      return i18next.t(RESULTS);
    case "costPerMainAction":
      return `${i18next.t(CPA)}`;

    case "impressionsByPlatform":
      return i18next.t(IMPRESSIONS_BY_PLATFORM);
    case "clicksByPlatform":
      return i18next.t(CLICKS_BY_PLATFORM);
    case "mainActionByPlatform":
      return i18next.t(MAIN_ACTIONS_BY_PLATFORM);

    default:
      return i18next.t(metric);
  }
};

export const getFromStatisticsAdsCampaign = (data) => {
  let totalStatistics = _.cloneDeep(data?.historicalStatistics?.total) || {};
  let previousPeriodStatistics =
    _.cloneDeep(data?.statisticsPreviousPeriod?.total) || {};

  let historicalStatistics =
    _.cloneDeep(data?.historicalStatistics?.historical) || {};
  let historicalPreviousPeriodStatistics =
    _.cloneDeep(data?.statisticsPreviousPeriod?.historical) || {};
  let statistics = _.cloneDeep(data?.statistics) || {};

  // If all statistics are empty, return empty
  if (
    _.isEmpty(historicalStatistics) &&
    _.isEmpty(statistics) &&
    _.isEmpty(totalStatistics) &&
    _.isEmpty(historicalPreviousPeriodStatistics) &&
    _.isEmpty(previousPeriodStatistics)
  ) {
    return {
      from: "empty",
      platforms: [],
      statistics: {},
      historical: {},
      previousPeriodStatistics: {},
      historicalPreviousPeriodStatistics: {},
    };
  }

  // If there is historical or total statistics, use them as main
  if (
    Object.keys(historicalStatistics).length > 0 ||
    Object.keys(totalStatistics).length > 0
  ) {
    let hasData = false;

    Object.keys(totalStatistics).forEach((platform) => {
      if (
        totalStatistics?.[platform]?.campaign?.spend > 0 ||
        totalStatistics?.[platform]?.campaign?.impressions > 0
      ) {
        hasData = true;
      }
    });
    Object.keys(historicalStatistics).forEach((snapshotKey) => {
      const snapshot = _.cloneDeep(historicalStatistics[snapshotKey]);
      delete snapshot.startDateTime;
      delete snapshot.endDateTime;

      Object.keys(snapshot).forEach((platform) => {
        if (
          snapshot?.[platform]?.campaign?.spend > 0 ||
          snapshot?.[platform]?.campaign?.impressions > 0
        ) {
          hasData = true;
        }
      });
    });

    // Check also previous period data for emptiness
    let hasPreviousPeriodData = false;
    Object.keys(previousPeriodStatistics).forEach((platform) => {
      if (
        previousPeriodStatistics?.[platform]?.campaign?.spend > 0 ||
        previousPeriodStatistics?.[platform]?.campaign?.impressions > 0
      ) {
        hasPreviousPeriodData = true;
      }
    });
    Object.keys(historicalPreviousPeriodStatistics).forEach((snapshotKey) => {
      const snapshot = _.cloneDeep(
        historicalPreviousPeriodStatistics[snapshotKey]
      );
      delete snapshot.startDateTime;
      delete snapshot.endDateTime;

      Object.keys(snapshot).forEach((platform) => {
        if (
          snapshot?.[platform]?.campaign?.spend > 0 ||
          snapshot?.[platform]?.campaign?.impressions > 0
        ) {
          hasPreviousPeriodData = true;
        }
      });
    });

    if (!hasData && !hasPreviousPeriodData) {
      return {
        from: "empty",
        platforms: [],
        statistics: {},
        historical: {},
        previousPeriodStatistics: {},
        historicalPreviousPeriodStatistics: {},
      };
    }

    if (_.isEmpty(historicalStatistics)) {
      const startDateTime = new Date(data.firstActiveTime).getTime();
      const endDateTime = new Date().getTime();

      historicalStatistics = {
        [getUniqueID()]: {
          startDateTime,
          endDateTime,
          ...totalStatistics,
        },
      };
    }

    // If previous period historical is empty but previousPeriodStatistics exists, create a single snapshot
    if (
      _.isEmpty(historicalPreviousPeriodStatistics) &&
      !_.isEmpty(previousPeriodStatistics)
    ) {
      const startDateTime = new Date(data.firstActiveTime).getTime();
      const endDateTime = new Date().getTime();

      historicalPreviousPeriodStatistics = {
        [getUniqueID()]: {
          startDateTime,
          endDateTime,
          ...previousPeriodStatistics,
        },
      };
    }

    const result = {
      from: "historical",
      platforms: Object.keys(totalStatistics),
      statistics: totalStatistics,
      historical: historicalStatistics,
      previousPeriodStatistics,
      historicalPreviousPeriodStatistics,
    };
    enrichResultWithGoogleMultipleConversions(result, data);
    return result;
  }

  // If only current statistics exist, use them as main
  let hasData = false;
  Object.keys(statistics).forEach((platform) => {
    if (
      statistics?.[platform]?.spend > 0 ||
      statistics?.[platform]?.impressions > 0
    ) {
      hasData = true;
    }
  });

  // Check also previous period data for emptiness in current mode
  let hasPreviousPeriodData = false;
  Object.keys(previousPeriodStatistics).forEach((platform) => {
    if (
      previousPeriodStatistics?.[platform]?.spend > 0 ||
      previousPeriodStatistics?.[platform]?.impressions > 0
    ) {
      hasPreviousPeriodData = true;
    }
  });

  if (!hasData && !hasPreviousPeriodData) {
    return {
      from: "empty",
      platforms: [],
      statistics: {},
      historical: {},
      previousPeriodStatistics: {},
      historicalPreviousPeriodStatistics: {},
    };
  }

  const result = {
    from: "current",
    platforms: Object.keys(statistics),
    statistics,
    historical: {},
    previousPeriodStatistics,
    historicalPreviousPeriodStatistics,
  };
  enrichResultWithGoogleMultipleConversions(result, data);
  return result;
};

export const getIsSpecialAdWithOnlyTitles = ({
  platform,
  objective,
  destinationType,
}) => {
  if (platform !== META && platform !== GOOGLE) {
    return false;
  }

  if (
    (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION ||
      objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION) &&
    destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION
  )
    return true;

  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION &&
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION
  )
    return true;

  return false;
};

export const getIsSpecialAdWithoutCallToAction = ({
  platform,
  objective,
  destinationTypeAdGroup,
  destinationTypeAd,
  callToAction,
}) => {
  if (platform !== META) {
    return false;
  }

  if (
    (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION ||
      objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION) &&
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION
  )
    return true;

  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION &&
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION &&
    callToAction === ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE
  )
    return true;

  const showDestinationTypeAd = getShowDestinationTypeAd({
    objective,
    destinationTypeAdGroup,
  });

  const isRequiredCallToAction =
    !showDestinationTypeAd ||
    (showDestinationTypeAd &&
      destinationTypeAd === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION);

  return !isRequiredCallToAction;
};

export const getIsCarouselAdIsAvailable = ({
  platform,
  destinationType,
  isPostAd = false,
  optimizationGoal = null,
}) => {
  if (platform !== META) {
    return false;
  }

  if (
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION ||
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION ||
    isPostAd
  ) {
    return false;
  }

  if (optimizationGoal === ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY) {
    return false;
  }

  return true;
};

export const getAdsTextsFormatted = ({ texts = [], format = "load" }) => {
  try {
    if (format === "load") {
      return texts.map((text) => {
        return {
          id: getUniqueID(),
          value: text,
        };
      });
    }

    return texts.map((text) => text.value);
  } catch (error) {
    store.dispatch(
      LaunchError(error, false, [], {
        functionName: "getAdsTextsFormatted",
        capture: "exception",
      })
    );
    console.error("Error getAdsTextsFormatted", error);
    return [];
  }
};

export const sumStatisticsAdsCampaign = ({ current = {}, addition = {} }) => {
  if (_.isEmpty(current) && _.isEmpty(addition)) return {};
  if (_.isEmpty(current)) return addition;
  const sumStatistics = {};

  const fieldsWithSum = [
    "spend",
    "reach",
    "click",
    "impressions",
    "mainAction",
  ];

  fieldsWithSum.forEach((field) => {
    sumStatistics[field] = (current[field] || 0) + (addition[field] || 0);
  });

  sumStatistics.frequency =
    (current.frequency || 0 + addition.frequency || 0) / 2;

  if (sumStatistics.spend && sumStatistics.impressions) {
    sumStatistics.cpm =
      (sumStatistics.spend / sumStatistics.impressions) * 1000;
  } else {
    sumStatistics.cpm = 0;
  }
  if (sumStatistics.spend && sumStatistics.click) {
    sumStatistics.cpc = sumStatistics.spend / sumStatistics.click;
  } else {
    sumStatistics.cpc = 0;
  }
  if (sumStatistics.click && sumStatistics.impressions) {
    sumStatistics.ctr = (sumStatistics.click / sumStatistics.impressions) * 100;
  } else {
    sumStatistics.ctr = 0;
  }
  if (sumStatistics.mainAction && sumStatistics.spend) {
    sumStatistics.costPerMainAction =
      sumStatistics.spend / sumStatistics.mainAction;
  }

  sumStatistics.currency = current.currency || "USD";
  sumStatistics.mainActionLabel = current.mainActionLabel || "";

  return sumStatistics;
};

export const getIsRequiredDestinationType = ({ platforms, objective }) => {
  if (
    platforms.includes(META) &&
    ADS_CAMPAIGN_OBJECTIVES_WITH_DESTINATION_TYPE_META.includes(objective)
  )
    return true;

  return false;
};

export const getIsAdWithSpecialConfigurationCustomizationPlacements = ({
  platform,
  destinationType = ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  isCarousel,
  customizationPlacements = [],
}) => {
  try {
    if (platform !== META) return false;

    if (destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION)
      return false;

    if (
      destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION
    )
      return false;

    if (isCarousel) return false;

    if (customizationPlacements.length === 0 || !customizationPlacements)
      return false;

    return true;
  } catch (error) {
    store.dispatch(
      LaunchError(error, false, [], {
        functionName: "getIsAdWithSpecialConfigurationCustomizationPlacements",
        capture: "exception",
      })
    );
    console.error(
      "Error getIsAdWithSpecialConfigurationCustomizationPlacements",
      error
    );
    return true;
  }
};

export const getAssetsGroupStructure = ({
  platform,
  campaignID,
  assetsGroupID,
}) => {
  if (platform === GOOGLE) {
    return {
      ageRange: [25, 40],
      businessName: "",
      campaignID,
      creationTime: new Date().getTime(),
      creationTimeNegative: -new Date().getTime(),
      descriptions: [
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
      ],
      status: ADS_CAMPAIGN_STATUS_DRAFT,
      destinationUrl: "",
      genders: {
        female: true,
        male: true,
      },
      id: assetsGroupID,
      imageUrls: [],
      logoUrls: [],
      longHeadlines: [
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
      ],
      name: "New assets group Google",
      platform,
      searchThemes: [],
      titles: [
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
      ],
      videoUrls: [],
    };
  }

  if (platform === LINKEDIN) {
    return {
      campaignID,
      creationTime: new Date().getTime(),
      creationTimeNegative: -new Date().getTime(),
      status: ADS_CAMPAIGN_STATUS_DRAFT,
      id: assetsGroupID,
      name: "New assets group LinkedIn",
      platform,
      // Single fields for Image/Video formats
      destinationUrl: "",
      callToAction: "",
      // Primary text (titles[0])
      titles: [
        {
          id: getUniqueID(),
          value: "",
        },
      ],
      // Headline (headlines[0] for single, headlines[i] for carousel cards)
      headlines: [
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
      ],
      // Description (only for Image format)
      descriptions: [
        {
          id: getUniqueID(),
          value: "",
        },
      ],
      // Media (mediaUrls[0] for single, mediaUrls[i] for carousel cards)
      mediaUrls: ["", ""],
      mediaData: [],
      isPostAd: false,
      // Destination URLs per card (for carousel)
      destinationUrls: [
        {
          id: getUniqueID(),
          value: "",
        },
        {
          id: getUniqueID(),
          value: "",
        },
      ],
    };
  }

  return {};
};

export const getAdGroupStructure = ({
  platform,
  campaignID,
  objective,
  adGroupID,
  adID,
  forcedData = {},
}) => {
  if (platform === META) {
    return {
      ads: [
        {
          adGroupID,
          callToAction: "",
          campaignID,
          creationTime: new Date().getTime(),
          creationTimeNegative: -new Date().getTime(),
          descriptions: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          destinationUrls: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          headlines: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          id: adID,
          isCarousel: false,
          isInstantExperience: false,
          isPostAd: false,
          reuseExistingCreative: false,
          adSetupMode: "create",
          creativeID: "",
          isPartnershipAd: false,
          partnershipOrderType:
            ADS_CAMPAIGN_META_PARTNERSHIP_AD_ORDER_SELF_FIRST,
          sponsorPageID: "",
          sponsorInstagramID: "",
          mediaData: [],
          mediaUrls: [],
          name: "New ad Meta",
          status: ADS_CAMPAIGN_STATUS_DRAFT,
          platform,
          titles: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          ...(forcedData?.ad || {}),
        },
      ],
      destinationType: "",
      trackingID: "",
      trackingCustomEventID: "",
      ageRange: [25, 40],
      budget: 0,
      campaignID,
      status: ADS_CAMPAIGN_STATUS_DRAFT,
      creationTime: new Date().getTime(),
      creationTimeNegative: -new Date().getTime(),
      customAudiences: [],
      excludedCustomAudiences: [],
      interests: [],
      behaviors: [],
      demographics: [],
      genders: {
        female: true,
        male: true,
      },
      id: adGroupID,
      locations: [],
      excludedLocations: [],
      name: "New ad group Meta",
      platform,
      typeBudget: "daily",
      isDynamicCreative: false,
      ...(forcedData?.adGroup || {}),
    };
  }
  if (platform === TIKTOK) {
    return {
      ads: [
        {
          adGroupID,
          callToAction: "",
          campaignID,
          creationTime: new Date().getTime(),
          creationTimeNegative: -new Date().getTime(),
          descriptions: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          destinationUrls: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          headlines: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          id: adID,
          mediaData: [],
          mediaUrls: [],
          name: "New ad TikTok",
          status: ADS_CAMPAIGN_STATUS_DRAFT,
          platform,
          titles: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
        },
      ],
      trackingID: "",
      trackingCustomEventID: "",
      ageRange: [25, 40],
      budget: 0,
      campaignID,
      creationTime: new Date().getTime(),
      creationTimeNegative: -new Date().getTime(),
      customAudiences: [],
      excludedCustomAudiences: [],
      status: ADS_CAMPAIGN_STATUS_DRAFT,
      interests: [],
      behaviors: [],
      genders: {
        female: true,
        male: true,
      },
      id: adGroupID,
      locations: [],
      name: "New ad group TikTok",
      platform,
      placements: [ADS_TIKTOK_PLACEMENT_TIKTOK],
      typeBudget: "daily",
    };
  }
  if (platform === GOOGLE) {
    if (objective === ADS_CAMPAIGN_TYPE_APP_OPTION) {
      return {
        campaignID,
        creationTime: new Date().getTime(),
        creationTimeNegative: -new Date().getTime(),
        titles: [
          {
            id: getUniqueID(),
            value: "",
          },
          {
            id: getUniqueID(),
            value: "",
          },
        ],
        descriptions: [
          {
            id: getUniqueID(),
            value: "",
          },
        ],
        destinationUrl: "",
        imageUrls: [],
        videoUrls: [],
        status: ADS_CAMPAIGN_STATUS_DRAFT,
        id: adGroupID,
        name: "New ad group Google",
        platform,
      };
    }
    return {
      ads: [
        {
          adGroupID,
          callToAction: "",
          campaignID,
          creationTime: new Date().getTime(),
          creationTimeNegative: -new Date().getTime(),
          descriptions: [
            {
              id: getUniqueID(),
              value: "",
            },
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          destinationUrls: [
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          headlines: [
            {
              id: getUniqueID(),
              value: "",
            },
            {
              id: getUniqueID(),
              value: "",
            },
          ],
          id: adID,
          status: ADS_CAMPAIGN_STATUS_DRAFT,
          name: "New ad Google",
          platform,
          titles: [
            {
              id: getUniqueID(),
              value: "",
            },
            {
              id: getUniqueID(),
              value: "",
            },
          ],
        },
      ],
      campaignID,
      creationTime: new Date().getTime(),
      creationTimeNegative: -new Date().getTime(),
      keywords: [],
      keywordsNegative: [],
      type: ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD_OPTION,
      webpages: [],
      status: ADS_CAMPAIGN_STATUS_DRAFT,
      id: adGroupID,
      name: "New ad group Google",
      platform,
    };
  }
};

export const getAdStructure = ({
  platform,
  campaignID,
  adGroupID,
  adID,
  forcedData,
}) => {
  if (platform === META) {
    return getAdGroupStructure({
      platform,
      campaignID,
      adGroupID,
      adID,
      forcedData,
    }).ads[0];
  }

  if (platform === TIKTOK) {
    return getAdGroupStructure({ platform, campaignID, adGroupID, adID })
      .ads[0];
  }

  if (platform === GOOGLE) {
    return getAdGroupStructure({ platform, campaignID, adGroupID, adID })
      .ads[0];
  }
};

export const getDateBasedLabel = (breakdown, startDateTime, endDateTime) => {
  if (!startDateTime || !endDateTime) {
    return getLabelCount(breakdown);
  }

  const startDate = new Date(
    new Date(startDateTime).getTime() + 24 * 60 * 60 * 1000
  );
  const endDate = new Date(endDateTime);

  switch (breakdown) {
    case "daily": {
      return i18next.t(DATE_DAY_AND_MONTH_SHORT, {
        date: startDate,
      });
    }

    case "weekly": {
      const startLabel = i18next.t(DATE_DAY_AND_MONTH_SHORT, {
        date: startDate,
      });
      const endLabel = i18next.t(DATE_DAY_AND_MONTH_SHORT, {
        date: endDate,
      });
      return `${startLabel} - ${endLabel}`;
    }

    case "monthly": {
      return i18next.t(MONTH_SHORT, {
        date: startDate,
      });
    }

    default:
      return getLabelCount(breakdown);
  }
};

export const getLabelCount = (breakdown) => {
  switch (breakdown) {
    case "daily":
      return DAY_COUNT;

    case "weekly":
      return WEEK_COUNT;

    case "monthly":
      return MONTH_COUNT;

    default:
      return WEEK_COUNT;
  }
};

export const getCostByMainCurrency = ({
  cost,
  costCurrency,
  mainCurrency,
  currenciesTax,
}) => {
  if (!cost) return { cost: 0, currency: mainCurrency };

  if (costCurrency === mainCurrency)
    return {
      cost,
      currency: mainCurrency,
    };

  const tax = currenciesTax[costCurrency];

  const newCost = numberDecimal(cost * tax);

  return {
    cost: newCost,
    currency: mainCurrency,
  };
};
export const METRICS_TO_CONVERT_TO_MAIN_CURRENCY = [
  "spend",
  "costPerMainAction",
  "cpm",
  "cpc",
];

export const getIsPostAdVisible = ({ objective, destinationType }) => {
  if (!ADS_CAMPAIGN_OBJECTIVES_WITH_IS_POST_AD.includes(objective)) {
    return false;
  }
  if (!destinationType) {
    return true;
  }
  return !ADS_CAMPAIGN_META_DESTINATION_TYPES_IS_POST_AD_EXCLUDED.includes(
    destinationType
  );
};

export const getShowDestinationTypeAd = ({
  objective,
  destinationTypeAdGroup,
}) => {
  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION ||
    objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION ||
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION
  ) {
    return false;
  }

  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION &&
    destinationTypeAdGroup !==
      ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION &&
    destinationTypeAdGroup !== ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION
  ) {
    return false;
  }

  // for awareness objective, engagement objective with on video destination type is available
  return true;
};

export const getShowSiteLinksAdMeta = ({
  objective,
  destinationType,
  destinationTypeAd,
}) => {
  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION ||
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION
  ) {
    return false;
  }

  if (destinationType !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION)
    return false;

  const showDestinationTypeAd = getShowDestinationTypeAd({
    objective,
    destinationTypeAdGroup: destinationType,
  });

  if (
    destinationTypeAd !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
    showDestinationTypeAd
  )
    return false;

  return true;
};

export const getShowCampaignType = ({ objective, platform }) => {
  if (platform !== META) return false;
  if (objective !== ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION) return false;

  return true;
};

export const getIsRequiredProductSetID = ({ objective, isCatalogCampaign }) => {
  if (objective !== ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION) return false;
  if (!isCatalogCampaign) return false;

  return true;
};

export const applyFiltersImportAdsCampaigns = ({
  campaign,
  status,
  name,
  filterByName = true,
}) => {
  let pass = true;
  if (status) {
    pass = campaign?.status === status;
  }
  if (filterByName && name) {
    pass = campaign?.name.toLowerCase().includes(name.toLowerCase());
  }

  return pass;
};
export const getMinimumBudget = ({
  platform,
  typeBudget,
  startDateTime,
  endDateTime,
  currency,
  currencyTax,
  useCampaignBudget,
}) => {
  if (ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD.includes(platform)) {
    const minBudgetUsd = ADS_CAMPAIGN_PLATFORM_MIN_BUDGET_IN_USD[platform];
    if (currency === "USD") return minBudgetUsd;
    if (
      typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION &&
      startDateTime &&
      endDateTime
    ) {
      const diffDays = differenceInDays(
        new Date(endDateTime),
        new Date(startDateTime)
      );
      const minBudget = Math.ceil(diffDays * (minBudgetUsd / currencyTax));

      return minBudget;
    }

    if (typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION) {
      const minBudget = Math.ceil(minBudgetUsd / currencyTax);

      return minBudget;
    }
  }

  if (platform === TIKTOK) {
    const currencyData = tiktokCurrenciesData[currency];
    if (currencyData) {
      const minDailyBudget = useCampaignBudget
        ? currencyData.minDailyBudgetCampaign
        : currencyData.minDailyBudget;
      if (
        typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION &&
        startDateTime &&
        endDateTime
      ) {
        const diffDays = differenceInDays(
          new Date(endDateTime),
          new Date(startDateTime)
        );
        const minBudget = Math.ceil(diffDays * minDailyBudget);

        return minBudget;
      }

      if (typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION) {
        return minDailyBudget;
      }
    }
  }

  return 0;
};

export const getLocationsAdapterToMap = (locations = []) => {
  const locationsAdapter = locations.map((location) => {
    const hasRadius = location.radius > 0;

    if (hasRadius) {
      // For custom radius locations
      return {
        ...location,
        type: "radius",
      };
    }

    if (location.type === "country") {
      return {
        ...location,
        name:
          location.name || location.country_name || location.country_code || "",
        country:
          location.name || location.country_name || location.country_code || "",
        type: "country",
      };
    }

    if (location.type === "region") {
      return {
        ...location,
        name: location.name || "",
        region: location.name || "",
        country: location.country_name || location.country_code || "",
      };
    }

    if (location.type === "city") {
      const result = {
        ...location,
        name: location.name || "",
        city: location.name || "",
        country: location.country_name || location.country_code || "",
      };

      return result;
    }

    return location;
  });

  return locationsAdapter;
};

export const getAdsCampaignsSchemasKey = ({ platform, objective }) => {
  if (platform !== GOOGLE) return platform;

  if (objective === ADS_CAMPAIGN_TYPE_SEARCH_OPTION) {
    return `${GOOGLE}_${ADS_CAMPAIGN_TYPE_SEARCH_OPTION}`;
  }

  if (objective === ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION) {
    return `${GOOGLE}_${ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION}`;
  }

  if (objective === ADS_CAMPAIGN_TYPE_APP_OPTION) {
    return `${GOOGLE}_${ADS_CAMPAIGN_TYPE_APP_OPTION}`;
  }

  return platform;
};

export const getPreviewAlertBudgets = ({ campaign, dispatch, mode }) => {
  const platforms = campaign.platforms || [];
  const budgetsArray = [];

  platforms.forEach((platform) => {
    const status = campaign?.states?.[platform];
    if (status !== ADS_CAMPAIGN_STATUS_DRAFT && mode === "create") return;
    const platformData = campaign.platformsData?.[platform] || {};

    if (
      BUDGETS_WITH_ONLY_CAMPAIGN_LEVEL.includes(platform) &&
      mode === "create"
    ) {
      const currency = dispatch(
        getCurrencyAdAccountPlatform({
          platform,
          integrationID: platformData.integrationID,
          adAccountID: platformData.adAccountID,
        })
      );
      budgetsArray.push({
        platform,
        budget: platformData.budget || 0,
        typeBudget: platformData.typeBudget,
        startDate: platformData.startDate,
        endDate: platformData.endDate,
        currency,
      });
      return;
    }

    if (
      PLATFORMS_WITH_USE_CAMPAIGN_BUDGET_OPTIONAL.includes(platform) &&
      platformData.useCampaignBudget &&
      mode === "create"
    ) {
      const currency = dispatch(
        getCurrencyAdAccountPlatform({
          platform,
          integrationID: platformData.integrationID,
          adAccountID: platformData.adAccountID,
        })
      );
      budgetsArray.push({
        platform,
        budget: platformData.budget || 0,
        typeBudget: platformData.typeBudget,
        currency,
      });
    }

    const adsGroups = campaign.adsGroups || {};

    Object.keys(adsGroups).forEach((key) => {
      const adsGroup = adsGroups[key];

      if (BUDGETS_WITH_ONLY_CAMPAIGN_LEVEL.includes(platform)) {
        return;
      }

      if (adsGroup.platform === platform) {
        if (
          (PLATFORMS_WITH_USE_CAMPAIGN_BUDGET_OPTIONAL.includes(platform) &&
            platformData.useCampaignBudget) ||
          (mode === "update" && adsGroup.status !== ADS_CAMPAIGN_STATUS_DRAFT)
        ) {
          return;
        }
        const currency = dispatch(
          getCurrencyAdAccountPlatform({
            platform,
            integrationID: platformData.integrationID,
            adAccountID: platformData.adAccountID,
          })
        );
        budgetsArray.push({
          platform,
          budget: adsGroup.budget || 0,
          typeBudget: adsGroup.typeBudget,
          startDate: adsGroup.startDate,
          endDate: adsGroup.endDate,
          currency,
        });
      }
    });
  });

  return budgetsArray;
};
